import React from "react";
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image";
import rightArrowBlue from '../../images/arrow-right-blue-textlink.svg';
import '../../sass/components/flexibleModules/_components.textComponentWithThumbImagesComponent.scss';

const TextComponentWithThumbImagesComponent = ({ data }) => {
    return (
        <div className="cp-textComponentWithThumbImagesComponent" style={{ backgroundColor: `${data.backgroundColor}` }}>
            <div className="cp-textComponentWithThumbImagesComponent__inner" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                {data.textComponentWithThumbImagesHeader &&
                    <h2 dangerouslySetInnerHTML={{__html: data.textComponentWithThumbImagesHeader}} />
                }
                {data.textComponentWithThumbImagesLink &&
                    <a className="l-textlink" href={data.textComponentWithThumbImagesLink.url} target={data.textComponentWithThumbImagesLink.target}>
                        <span>{data.textComponentWithThumbImagesLink.title}</span> 
                        <img src={rightArrowBlue} alt="" />
                    </a>
                }
                {data.textComponentWithThumbImagesAuthors &&
                    <div className="cp-textComponentWithThumbImagesComponent__authors">
                        {data.textComponentWithThumbImagesAuthors.map((author, index) => (
                            <span className={`l-absolute${index+1}`} key={index}>
                                <GatsbyImage image={getImage(author.gatsbyImage)} alt={author.altText} />
                            </span>
                        ))}
                    </div>
                }
            </div>
        </div>
    );
}

export default TextComponentWithThumbImagesComponent;